
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1063 708.66","version":"1"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","fill":"#e80000","d":"M0 0h1063v708.66H0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","fill":"#fff","d":"M0 0h1063v354.33H0z"}}),_c('path',{attrs:{"d":"M0 0l529.732 353.88L0 707.3V0z","fill-rule":"evenodd","fill":"#00006f"}})])
          )
        }
      }
    